import React from 'react'
import {ShowGuesser} from '@api-platform/admin'
import {TextField, NumberField, ReferenceField} from 'react-admin';
import {useTranslation} from "react-i18next";

function Show(props) {
    const {t} = useTranslation()
    return (
        <ShowGuesser {...props}>
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <TextField source="code" label={t('admin.code')}/>
            <TextField source="foreignId" label={'foreignId'}/>
            <ReferenceField source="media" reference="dictionary/medias" link={false} label={t('admin.media')}
                            sortable={false}>
                <TextField source="name"/>
            </ReferenceField>
        </ShowGuesser>
    )
}

export default Show
